export default __webpack_public_path__ + "static/media/clothing_dark.0e38689c.png";